import { TrendingUp, DollarSign, Shield, Landmark, BarChart3 } from "lucide-react";

interface NetWorthSummaryProps {
  netWorth: number;
  liquidCash: number;
  reserves: number;
  retirement: number;
  investments: number;
}

const NetWorthSummary = ({ netWorth, liquidCash, reserves, retirement, investments }: NetWorthSummaryProps) => {
  const segments = [
    { label: "Liquid", value: liquidCash, icon: DollarSign, color: "text-primary" },
    { label: "Reserves", value: reserves, icon: Shield, color: "text-accent" },
    { label: "Retirement", value: retirement, icon: Landmark, color: "text-secondary" },
    { label: "Invested", value: investments, icon: BarChart3, color: "text-primary" },
  ];

  return (
    <div className="glass-card p-6 space-y-4">
      <div className="flex items-center gap-2">
        <TrendingUp className="w-5 h-5 text-primary" />
        <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Net Worth</span>
      </div>
      <p className="font-heading font-bold text-4xl text-gradient-blue">
        ${netWorth.toLocaleString()}
      </p>
      <div className="grid grid-cols-2 gap-3">
        {segments.map((seg) => (
          <div key={seg.label} className="flex items-center gap-2">
            <seg.icon className={`w-3.5 h-3.5 ${seg.color}`} />
            <div>
              <p className="text-xs text-muted-foreground">{seg.label}</p>
              <p className="text-sm font-heading font-semibold text-foreground">
                ${seg.value.toLocaleString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NetWorthSummary;
